import { redirect } from "react-router";
import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		index: true,
		loader: () => redirect(PAGES.service.sub.users),
	},
	{
		path: PAGES.service.sub.gdpr,
		lazy: () =>
			import("src/module--admin/pages/Gdpr.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.service.sub.ondemandmessageaction,
		lazy: () =>
			import("src/module--journey/pages/OnDemandMessage.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.service.sub.ondemandmessageactionLanding,
		lazy: () =>
			import("src/module--admin/pages/OnDemandMessageLanding.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: "*",
		lazy: () =>
			import("src/module--admin/pages/EmbeddedResource.page").then(
				convertFrameworkRoute,
			),
	},
];
